import React, { useEffect, useMemo, useState } from 'react';
import { UsersRound, User as UserIcon, BanknoteArrowUp, ChevronLeft, Wallet, UserSquare2 } from 'lucide-react';

import Button from '../../components/ui/buttons/Button';
import DashboardTab from '../planner/client/dashboard/DashboardTab';

import SuitabilityProfiles from './walletConfigs/SuitabilityProfiles';
import WalletProfiles from './walletConfigs/WalletProfiles';
import Wallets from './walletConfigs/Wallets/Wallets';

const WalletConfigs = () => {
  const tabs = [
    { key: 'suitability_profiles', label: 'PERFIS DE SUITABILITY', icon: UsersRound },
    { key: 'wallet_profiles', label: 'PERFIS DE CARTEIRA', icon: UserSquare2 },
    { key: 'wallets', label: 'CARTEIRAS', icon: Wallet },
  ];

  const validTabKeys = tabs.map((t) => t.key);

  const [activeTab, setActiveTab] = useState(() => {
    const url = new URL(window.location.href);
    const tabFromUrl = url.searchParams.get('tab');
    if (tabFromUrl && validTabKeys.includes(tabFromUrl)) return tabFromUrl;
    return tabs[0].key;
  });

  const handleTabChange = (key) => {
    setActiveTab(key);
    const url = new URL(window.location);
    url.searchParams.set('tab', key);
    window.history.pushState({}, '', url);
  };

  return (
    <div className="p-0 flex flex-col h-full gap-5">
      {/* Header */}
      <div className="flex justify-between items-center">
        <span className="flex items-center gap-2">
          <Wallet className="text-tealMedium" size={20} strokeWidth={1.5} />
          <h1 className="text-2xl font-semibold text-blueDarker">Carteiras e Perfis</h1>
        </span>

        <div className="flex items-center gap-3">
          <Button icon={ChevronLeft} onClick={() => window.history.back()}>
            VOLTAR
          </Button>
        </div>
      </div>
      <div className="flex gap-5 flex-row">
        {tabs.map((tab) => (
          <DashboardTab
            key={tab.key}
            label={tab.label}
            active={activeTab === tab.key}
            completed={tab.completed}
            py="py-5"
            icon={tab.icon}
            onClick={() => handleTabChange(tab.key)}
          />
        ))}
      </div>
      {activeTab === 'suitability_profiles' && <SuitabilityProfiles />}
      {activeTab === 'wallet_profiles' && <WalletProfiles />}
      {activeTab === 'wallets' && <Wallets />}
    </div>
  );
};

export default WalletConfigs;
